module.exports = __webpack_public_path__ + "img/tableAnalysisChart.8bf2c57e.png";